<footer class="footer-container">
  <div>
    © {{currentDate}} BarnManager
  </div>
  <div>
    (Version {{ version }})
  </div>
</footer>
